export const GET_LIST_REQUEST = "AutographServers/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "AutographServers/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "AutographServers/GET_LIST_FAILURE";

export const GET_ITEM_REQUEST = "AutographServers/GET_ITEM_REQUEST";
export const GET_ITEM_SUCCESS = "AutographServers/GET_ITEM_SUCCESS";
export const GET_ITEM_FAILURE = "AutographServers/GET_ITEM_FAILURE";

export const ADD_REQUEST = "AutographServers/ADD_REQUEST";
export const ADD_SUCCESS = "AutographServers/ADD_SUCCESS";
export const ADD_FAILURE = "AutographServers/ADD_FAILURE";

export const EDIT_REQUEST = "AutographServers/EDIT_REQUEST";
export const EDIT_SUCCESS = "AutographServers/EDIT_SUCCESS";
export const EDIT_FAILURE = "AutographServers/EDIT_FAILURE";

export const DELETE_REQUEST = "AutographServers/DELETE_REQUEST";
export const DELETE_SUCCESS = "AutographServers/DELETE_SUCCESS";
export const DELETE_FAILURE = "AutographServers/DELETE_FAILURE";